
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';import useQuasar from 'quasar/src/composables/use-quasar.js';
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: 'confirm-deletion-dialog',
    props: {
        entityType: {
            type: String,
            required: true
        },
        identifier: {
            type: String,
            required: true
        },
        deleteCallback: {
            type: Function as PropType<() => Promise<void>>,
            required: true
        }
    },
    setup (props) {
        const { dialogRef, onDialogCancel, onDialogHide } = useDialogPluginComponent()
        const $q = useQuasar()
        async function deleteEntity () {
            try {
                await props.deleteCallback()
                $q.notify({
                    color: 'positive',
                    message: `Selected ${props.entityType} has been deleted`
                })
            } catch (error) {
                $q.notify({
                    color: 'negative',
                    message: error.toString()
                })
            }
        }
        return {
            deleteEntity,
            dialogRef,
            onDialogCancel,
            onDialogHide
        }
    }
})
